import React, { useContext, useEffect, useState } from 'react';
import MsgUtils from '../Tools/MsgUtils';
import CircleLoader from "react-spinners/CircleLoader";
import UtilsBufer from '../Tools/UtilsBufer';
import { ReactSession } from "react-client-session";
import UtilsListas from '../Tools/UtilsListas';
import VerificarPermisos from '../Tools/VerificarPermisos';
import addButton from "../../assets/addButon.png";
import { Context } from './PrincipalComunicados';
const server = process.env.REACT_APP_SERVER;

function NuevosComunicados(props) {
    const { regional,actualizar,setSelectComu,tipo,setModalNuevoComunicado,setModalDetalle } = props;
    const {estadoC} = useContext(Context)
    const [loading, setLoading] = useState(true);
    const [comunicados, setComunicados] = useState([]);
    const formatoFecha = (fecha) => {
        let date = new Date(Date.parse(fecha));
        return `${date.getDate()}/${date.toLocaleString('default', { month: 'long' })}/${date.getFullYear()}`;
    }
    async function send(tipo, mensage, elegido) {
        var idUsuario = ReactSession.get('idSession');
        var regional = ReactSession.get('regional');
        var empresaSucursal = ReactSession.get('empresaSucursal');
        var info = JSON.parse(localStorage.getItem('info'));
        await fetch(`${server}/comunicados/lista/respuesta`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            vId: 0, idUsuario, regional, mensage, empresaSucursal, elegido, tipo,
          })
        })
          .then(res => res.json())
          .then(data => {
            if (data.ok) {
              setModalDetalle(true);
            } else {
              MsgUtils.msgError(data.error);
            }
          })
          .catch(err => console.log(err));
      }
    const verDetalles = async (e) => {
        var id= e.target.id;
        if (id !== undefined) {
          var dato = UtilsListas.getElemento(comunicados, id);
          setSelectComu(dato);
          await send('VIS', '', id);
        }
      };
    useEffect(() => {
        console.log(estadoC, "valor del context");
        var fecha = new Date();
        var dateFin = fecha.toISOString().substring(0, 10);
        var dateIni = (new Date(fecha.setDate(fecha.getDate() - 30))).toISOString().substring(0, 10);
        fetch(`${server}/comunicados/getComunicadosNuevos`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                dateIni, dateFin, regional, info: JSON.parse(localStorage.getItem("info")),tipo
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    console.log(data.ok);
                    setComunicados(data.ok);
                    setLoading(false);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }, [actualizar])
    return (
        <div className=''>
            <CircleLoader className="mx-auto my-auto" color='#F95E10' loading={loading} size={200} />
            <div className={loading ? 'd-none' : 'table-responsive'}>
                <table className="table table-striped table-bordered table-sm table-hover">
                    <thead className='bg-secondary bg-gradient text-center fw-bold text-light'>
                        <tr>
                            <th scope="col">FECHA</th>
                            <th scope="col">DE:</th>
                            <th scope="col">Descripción</th>
                            <th scope="col">Mas</th>
                        </tr>
                    </thead>
                    <tbody>
                        {comunicados.map((item) => {
                            return (
                                <tr key={item.ID_COMUNICADO} className="my-auto">
                                    <th className="col-1">{formatoFecha(item.FECHA)}</th>
                                    <td className='col-4'>
                                        <div className="card bg-transparent flex-row m-0 p-0" style={{border:'none'}}>
                                            {UtilsBufer.getFotoCard(item.FOTO,40)}
                                            <div className='ps-2 my-auto d-none d-sm-inline'>
                                                <div className="cargoHeader fw-bold">{item.COLABORADOR}</div>
                                                <div className='cargoHeader '>{item.CARGO}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{item.DESCRIPCION}</td>
                                    <td><a className='btn btn-transparent fs-4 m-0 p-0' 
                                        id={item.ID_COMUNICADO}
                                        onClick={verDetalles}>
                                        <i id={item.ID_COMUNICADO} className="bi bi-eye-fill"></i></a>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {VerificarPermisos.validarPermiso(16)&&
            <div className={`fixed-bottom text-end m-2`}>
                <img src={addButton} height='50' onClick={() => setModalNuevoComunicado(true)}></img>
            </div>}
        </div>
    )
}

export default NuevosComunicados
